import ClientBalanceCard from '@/components/client/client-balance-card';
import {
	$appendClientDetailBalances,
	$clientDetailBalances,
	$setClientDetailBalances,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { getMockBalancesForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';

interface ClientBalancesListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	onCopy: (text: string) => void;
}

export default function ClientBalancesList({ clientId, searchText, enabled, onCopy }: ClientBalancesListProps) {
	const [balances, setBalances, appendBalances] = useUnit([
		$clientDetailBalances,
		$setClientDetailBalances,
		$appendClientDetailBalances,
	]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientBalances,
		responseEvent: SOCKET_EVENTS.addClientBalances,
		items: balances,
		setItems: setBalances,
		appendItems: appendBalances,
		getItemId: item => item.id,
		emptyLabel: 'Сообщений с балансом нет',
		renderItem: balance => <ClientBalanceCard balance={balance} onCopy={onCopy} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			const page = paginateMockItems(
				getMockBalancesForClient(clientId),
				{ cursor, searchText: q },
				(item, query) =>
					item.text.toLowerCase().includes(query) ||
					item.sender.toLowerCase().includes(query) ||
					(item.cardNumber?.toLowerCase().includes(query) ?? false),
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
